import { isNil, isEmpty } from '@soltalabs/ramda-extra'
import React, { useEffect, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { getCrews } from '../../../modules/crews'
import { fetchScheduledJobs } from '../../../modules/scheduler'

import { SchedulerPanelsSectionView } from './view'

function SchedulerPanelsSection() {
  const dispatch = useDispatch()
  const crews = useSelector(getCrews)
  const fetchedCrewIds = useRef(new Set())

  useEffect(() => {
    if (!isNil(crews) && !isEmpty(crews)) {
      const unfetched = crews.filter((crew) => !fetchedCrewIds.current.has(crew.id))
      unfetched.forEach((crew) => {
        fetchedCrewIds.current.add(crew.id)
        dispatch(fetchScheduledJobs.request(crew.id))
      })
    }
  }, [dispatch, crews])

  return <SchedulerPanelsSectionView crews={crews} />
}

export { SchedulerPanelsSection }
